import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { AuthService, EnvironmentConfig, IUser, Listing } from '@clooper/core';
import { faHeart, faMapMarkerAlt, faBed, faBath, faBadgeCheck, faArrowRight, faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import lozad from 'lozad'
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-property-search-popup',
  templateUrl: './property-search-popup.component.html',
  styleUrls: ['./property-search-popup.component.scss']
})
export class PropertySearchPopupComponent implements OnInit {

  icons = {
    map: faMapMarkerAlt,
    bed: faBed,
    bath: faBath,
    trusted: faBadgeCheck,
    arrowRight: faArrowRight,
    arrowLeft: faArrowLeft,
    heart: faHeart


  }
  splicedTitle: string | undefined

  @Input() listing: Listing | null
  @Output() onlistinghovered: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();

  @Input() isMobile: boolean
  bsModalRef?: BsModalRef;

  favourite = false;
  user: IUser

  constructor(
    @Optional() private authService: AuthService,
    private config: EnvironmentConfig


  ) { }

  ngOnInit(): void {
    if (location.origin === this.config.webappUrl) {
      this.user = this.authService.getAuthorizedUser()

      if (this.listing !== null && this.listing?.liked === true) {
        this.favourite = true;
      } else if (this.listing !== null && this.listing?.likes) {
        this.getPropertyLikeForAUser(this.listing?.likes)
      }
    }
    let title = (this.listing?.room || this.listing?.property)?.display_name?.slice(0, 10) || ''
    if (title?.length > 10) {
      this.splicedTitle = (this.listing?.room || this.listing?.property)?.display_name?.slice(0, 10) + "..."
    } else {
      this.splicedTitle = (this.listing?.room || this.listing?.property)?.display_name
    }



    setTimeout(() => {
      const observer = lozad();
      observer.observe();
    }, 100);



  }

  getPropertyLikeForAUser(id: string[]) {
    id.forEach(element => {
      if (element === this.user.id) {
        this.favourite = true;
      }
    });


  }




}
